import React from 'react';
import {Text, View, StyleSheet } from '@react-pdf/renderer';
import {useTranslation} from 'react-i18next';

const borderColor = '#90e5fc'
const styles = StyleSheet.create({
    row: {
        fontSize: 20,
        display: 'flex',
        alignItems: 'flex-start',
       
        flexDirection: 'row',
        marginTop: '0px',
        marginLeft: '40px',
        marginRight: '40px',
        marginBootom: '10px',
        
      
        flexGrow: 1,
    },
    itemName: {
        width: '35%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
    },
    catalog: {
        width: '10%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
    },
    qty: {
        width: '10%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
    },
    um: {
        width: '5%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
    },
    priceOnePcs: {
        width: '15%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
    },
    vat: {
        width: '5%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
        marginRight: '5px'
    },
    priceExcludeVat: {
        width: '10%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
    },
    priceIncludeVat: {
        width: '10%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
    },
  
  });


const InvoiceTableFooter = ({items}) => {

    const [t] = useTranslation();     
    const {i18n} = useTranslation();

    const totalExcludeVat = items ? items.map(item => item.totalPriceExcludeVat)
        .reduce((accumulator, currentValue) => accumulator + currentValue , 0) : 0

    const totalIncludeVat = items ? items.map(item => item.totalPriceIncludeVat)
        .reduce((accumulator, currentValue) => accumulator + currentValue , 0) : 0

    return(    
        <View style={styles.row}>            
            <Text style={styles.itemName}></Text>
            <Text style={styles.catalog}></Text>
            <Text style={styles.qty}></Text>
            <Text style={styles.um}></Text>
            <Text style={styles.priceOnePcs}></Text>
            <Text style={styles.vat}>{t('document.label.total')}</Text>
            <Text style={styles.priceExcludeVat}>{ Number.parseFloat(totalExcludeVat).toFixed(2)}</Text>
            <Text style={styles.priceIncludeVat}>{ Number.parseFloat(totalIncludeVat).toFixed(2)}</Text>
        </View>
    )
};
  
  export default InvoiceTableFooter